// extracted by mini-css-extract-plugin
export var cardLayout = "_1m-1";
export var paginationContainer = "_1m-0";